export default __webpack_public_path__ + "static/media/open-icon.9c2233a4.png";